import { render, staticRenderFns } from "./ProfessionInfoCarousel.vue?vue&type=template&id=cf491be8&scoped=true"
import script from "./ProfessionInfoCarousel.vue?vue&type=script&lang=ts"
export * from "./ProfessionInfoCarousel.vue?vue&type=script&lang=ts"
import style0 from "./ProfessionInfoCarousel.vue?vue&type=style&index=0&id=cf491be8&prod&lang=scss"
import style1 from "./ProfessionInfoCarousel.vue?vue&type=style&index=1&id=cf491be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf491be8",
  null
  
)

export default component.exports